import { Controller } from "@hotwired/stimulus"

// shows the content only while the checkbox is ticked
export default class extends Controller {
  static targets = ["checkbox", "content"]

  toggle() {
    this.contentTarget.hidden = !this.checkboxTarget.checked
  }
}
